import { render, staticRenderFns } from "./StartNode.vue?vue&type=template&id=944ff616&scoped=true&"
import script from "./StartNode.vue?vue&type=script&lang=js&"
export * from "./StartNode.vue?vue&type=script&lang=js&"
import style0 from "./StartNode.vue?vue&type=style&index=0&id=944ff616&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944ff616",
  null
  
)

export default component.exports